import {
  IconAirConditioning,
  IconArcticReindeer,
  IconAssistanceAnimals,
  IconAtlanticSturgeon,
  IconBalconyPatio,
  IconBarbecueUtensils,
  IconBathrooms,
  IconBbqGrill,
  IconBeardedVulture,
  IconBedBreakfastHouse,
  IconBedrooms,
  IconBeds,
  IconBidet,
  IconBirdwatching,
  IconBoardGame,
  IconBonellisEagle,
  IconBooksMagazines,
  IconBowlsChopsticksCups,
  IconBrownBear,
  IconCabinTinyHouse,
  IconCanoeingKayaking,
  IconCarbonMonoxideAlarm,
  IconCastleTower,
  IconChamois,
  IconChildrensToys,
  IconCinereousVulture,
  IconCleaningProducts,
  IconClothesDryingRack,
  IconClothesStorage,
  IconCoffeeMaker,
  IconCooker,
  IconCoookingBasics,
  IconCrossCountrySkiing,
  IconDalmatianPelican,
  IconDarkSkiesStargazing,
  IconDedicatedWorkspace,
  IconDiningTable,
  IconDishesCutlery,
  IconDogSledding,
  IconEagleOwl,
  IconEducationalExperience,
  IconEgyptianVulture,
  IconEurasianBeaver,
  IconEurasianElk,
  IconEurasianLynx,
  IconEuropeanBison,
  IconEuropeanHamster,
  IconEuropeanRabbit,
  IconExerciseEquipment,
  IconExtraPillowsBlankets,
  IconFallowDeer,
  IconFarm,
  IconFarmCoExistence,
  IconFireExtinguisher,
  IconFirepit,
  IconFirstAidKit,
  IconFlatApartment,
  IconForaging,
  IconFourByFourExperience,
  IconFreshwaterPearlMussel,
  IconFridge,
  IconGastronomyLocal,
  IconGoldenEagle,
  IconGoldenJackal,
  IconGreySeal,
  IconGreyWolf,
  IconGriffonVulture,
  IconGuestHouse,
  IconGuests,
  IconHairDryer,
  IconHammock,
  IconHangers,
  IconHikeInOut,
  IconWildlifeCoexistence,
  IconHiking,
  IconHorseRidingTrek,
  IconHotel,
  IconHotTub,
  IconHotWater,
  IconHouse,
  IconIberianLynx,
  IconIbex,
  IconImperialEagle,
  IconIndoorFireplace,
  IconInForest,
  IconInLocalCommunity,
  IconInNature,
  IconInTheMountains,
  IconIron,
  IconKitchen,
  IconKulan,
  IconLeadershipTrail,
  IconLuggageDropOff,
  IconMosquitoNet,
  IconMountainBiking,
  IconNearLakeBeach,
  IconOutdoorDiningArea,
  IconOutdoorFurniture,
  IconPeaceful,
  IconPetsAllowed,
  IconPiano,
  IconPortableFans,
  IconPotsPans,
  IconPrivateDoorEntrance,
  IconPrivateGateEntrance,
  IconRecordPlayer,
  IconRedDeer,
  IconRiverWetlandBoatTrip,
  IconRockClimbingFerrata,
  IconRoeDeer,
  IconRoomDarkeningBlinds,
  IconSalmon,
  IconScenicViewOnNature,
  IconSelfCheckIn,
  IconShampoo,
  IconSmallBackGarden,
  IconSmokeAlarm,
  IconSmokingAllowed,
  IconSnowshoeing,
  IconStaffAvailable,
  IconSteppeMarmot,
  IconSuslik,
  IconSwimmingPool,
  IconTauros,
  IconTentYurt,
  IconToiletPaperSoap,
  IconTowelsBedLinen,
  IconTreeHouse,
  IconTrout,
  IconTv,
  IconVolunteering,
  IconWashingMachine,
  IconWaterBuffalo,
  IconWhiteClawedCrayfish,
  IconWhiteTailedEagleFlying,
  IconWifi,
  IconWildcat,
  IconWildHorse,
  IconWildlifePhotography,
  IconWildlifeTracking,
  IconWineGlass,
  IconWorkshop,
} from '../components';

export const renderCustomIcons = {
  ['type-house']: <IconHouse />,
  ['type-appartment']: <IconFlatApartment />,
  ['type-bandb']: <IconBedBreakfastHouse />,
  ['type-cabin']: <IconCabinTinyHouse />,
  ['type-castle']: <IconCastleTower />,
  ['type-farm']: <IconFarm />,
  ['type-guesthouse']: <IconGuestHouse />,
  ['type-hotel']: <IconHotel />,
  ['type-tent']: <IconTentYurt />,
  ['type-treehouse']: <IconTreeHouse />,
  listingfield_maximumguests: <IconGuests />,
  listingfield_bedooms: <IconBedrooms />,
  listingfield_beds: <IconBeds />,
  listingfield_bathroom: <IconBathrooms />,
  Wifi: <IconWifi />,
  TV: <IconTv />,
  Recordplayer: <IconRecordPlayer />,
  Booksmagazines: <IconBooksMagazines />,
  Childrenstoys: <IconChildrensToys />,
  Boardgames: <IconBoardGame />,
  Exerciseequipment: <IconExerciseEquipment />,
  Indoorfireplace: <IconIndoorFireplace />,
  Dedicatedworkspace: <IconDedicatedWorkspace />,
  Portablefans: <IconPortableFans />,
  Airconditioning: <IconAirConditioning />,
  Piano: <IconPiano />,
  Hairdryer: <IconHairDryer />,
  Cleaningproducts: <IconCleaningProducts />,
  Shampoo: <IconShampoo />,
  Bidet: <IconBidet />,
  Hotwater: <IconHotWater />,
  Washingmachine: <IconWashingMachine />,
  Essentialssoapetc: <IconToiletPaperSoap />,
  Towelsbedlinen: <IconTowelsBedLinen />,
  Extrapillowsandblankets: <IconExtraPillowsBlankets />,
  Hangers: <IconHangers />,
  Roomdarkeningblinds: <IconRoomDarkeningBlinds />,
  Iron: <IconIron />,
  Clothesdryingrack: <IconClothesDryingRack />,
  Mosquitonet: <IconMosquitoNet />,
  Clothesstorage: <IconClothesStorage />,
  Kitchen: <IconKitchen />,
  Cooker: <IconCooker />,
  Fridge: <IconFridge />,
  Potsandpans: <IconPotsPans />,
  Cookingbasicsoilsalt: <IconCoookingBasics />,
  Dishesandcutlery: <IconDishesCutlery />,
  Bowlschopstickscups: <IconBowlsChopsticksCups />,
  Coffeemaker: <IconCoffeeMaker />,
  Wineglasses: <IconWineGlass />,
  Barbecueutensils: <IconBarbecueUtensils />,
  Diningtable: <IconDiningTable />,
  Outdoordiningarea: <IconOutdoorDiningArea />,
  Balconyorpatio: <IconBalconyPatio />,
  Privatebackgarden: <IconSmallBackGarden />,
  Outdoorfurniture: <IconOutdoorFurniture />,
  Swimmingpool: <IconSwimmingPool />,
  Hottub: <IconHotTub />,
  BBQgrill: <IconBbqGrill />,
  Firepit: <IconFirepit />,
  Hammock: <IconHammock />,
  Privatedoorentrance: <IconPrivateDoorEntrance />,
  Privategateentrance: <IconPrivateGateEntrance />,
  Petsallowed: <IconPetsAllowed />,
  Assistanceanimals: <IconAssistanceAnimals />,
  Luggagedropoff: <IconLuggageDropOff />,
  Smokingallowed: <IconSmokingAllowed />,
  Selfcheckin: <IconSelfCheckIn />,
  Buildingstaff247: <IconStaffAvailable />,
  Smokealarm: <IconSmokeAlarm />,
  Carbonmonoxidealarm: <IconCarbonMonoxideAlarm />,
  Fireextinguisher: <IconFireExtinguisher />,
  Firstaidkit: <IconFirstAidKit />,
  Hiking: <IconHiking />,
  Wildlifetracking: <IconWildlifeTracking />,
  Wildlifephotography: <IconWildlifePhotography />,
  Birdwatching: <IconBirdwatching />,
  Gastronomylocal: <IconGastronomyLocal />,
  Workshop: <IconWorkshop />,
  ['Farmco-existence']: <IconFarmCoExistence />,
  Educationalexperience: <IconEducationalExperience />,
  Leadershiptrail: <IconLeadershipTrail />,
  Volunteering: <IconVolunteering />,
  Darkskiesstargazing: <IconDarkSkiesStargazing />,
  Foraging: <IconForaging />,
  Riverorwetlandboattrip: <IconRiverWetlandBoatTrip />,
  Canoeingorkayaking: <IconCanoeingKayaking />,
  Horseridingortrek: <IconHorseRidingTrek />,
  Rockclimbingviaferrata: <IconRockClimbingFerrata />,
  Mountainbiking: <IconMountainBiking />,
  ['4x4experience']: <IconFourByFourExperience />,
  Snowshoeing: <IconSnowshoeing />,
  Crosscountryskiing: <IconCrossCountrySkiing />,
  Dogsledding: <IconDogSledding />,
  Arcticreindeer: <IconArcticReindeer />,
  Chamois: <IconChamois />,
  Europeanbison: <IconEuropeanBison />,
  Eurasianelk: <IconEurasianElk />,
  Tauros: <IconTauros />,
  Wildhorse: <IconWildHorse />,
  Kulan: <IconKulan />,
  Waterbuffalo: <IconWaterBuffalo />,
  Iberianibex: <IconIbex />,
  Reddeer: <IconRedDeer />,
  Fallowdeer: <IconFallowDeer />,
  Roedeer: <IconRoeDeer />,
  Europeanrabbit: <IconEuropeanRabbit />,
  Eurasianbeaver: <IconEurasianBeaver />,
  Steppemarmot: <IconSteppeMarmot />,
  Europeanhamster: <IconEuropeanHamster />,
  Suslik: <IconSuslik />,
  Greywolf: <IconGreyWolf />,
  Brownbear: <IconBrownBear />,
  Iberianlynx: <IconIberianLynx />,
  Eurasianlynx: <IconEurasianLynx />,
  Wildcat: <IconWildcat />,
  Goldonjackal: <IconGoldenJackal />,
  Greyseal: <IconGreySeal />,
  Cinereousvulture: <IconCinereousVulture />,
  Griffonvulture: <IconGriffonVulture />,
  Egyptianvulture: <IconEgyptianVulture />,
  Beardedvulture: <IconBeardedVulture />,
  Whitetailedeagle: <IconWhiteTailedEagleFlying />,
  Goldeneagle: <IconGoldenEagle />,
  Imperialeagle: <IconImperialEagle />,
  Bonelliseagle: <IconBonellisEagle />,
  Dalmatianpelican: <IconDalmatianPelican />,
  Eagleowl: <IconEagleOwl />,
  Atlanticsturgeon: <IconAtlanticSturgeon />,
  Salmon: <IconSalmon />,
  Trout: <IconTrout />,
  Whiteclawedcrayfish: <IconWhiteClawedCrayfish />,
  Freshwaterpearlmussel: <IconFreshwaterPearlMussel />,
  ['characteristics-innature']: <IconInNature />,
  ['characteristics-incommunity']: <IconInLocalCommunity />,
  ['characteristics-Scenicviewnature']: <IconScenicViewOnNature />,
  ['characteristics-inforest']: <IconInForest />,
  ['characteristics-inmountains']: <IconInTheMountains />,
  ['characteristics-nearlakeorbeach']: <IconNearLakeBeach />,
  ['characteristics-peaceful']: <IconPeaceful />,
  ['characteristics-hikeinout']: <IconHikeInOut />,
  ['characteristics-wildlife']: <IconWildlifeCoexistence />,
};
